// Empty default => same-origin (relative) API calls. The admin.cloudgenomics.net
// Apache vhost proxies /api/ to the backend, so `${API_BASE}/api/...` resolves to
// https://admin.cloudgenomics.net/api/... — same-origin, no CORS/preflight.
// Override with REACT_APP_API_BASE only if the API must be reached cross-origin.
const API_BASE = process.env.REACT_APP_API_BASE || "";
export default API_BASE;
